import TrainingProgressDashboard from "@/components/training/TrainingProgressDashboard";

function MetricTip({ label, tipKey, tooltips }) {
  const tip = tooltips?.[tipKey];
  if (!tip) return null;
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      <span
        title={tip}
        className="cursor-help text-xs rounded-full border px-1"
        style={{ borderColor: "rgba(22,25,28,.25)", color: "rgba(22,25,28,.6)" }}
        aria-label={tip}
        data-testid={`metric-tip-${tipKey}`}
      >
        i
      </span>
    </span>
  );
}

export default function PerformanceDashboardPanel({ progression, testIdPrefix = "instructor" }) {
  if (!progression) return null;

  const counts = progression.session_counts || {};
  const tips = progression.metric_tooltips || {};
  const overall = progression.overall_summary;

  return (
    <section
      className="audit-surface audit-section"
      aria-label="Performance dashboard"
      data-testid={`${testIdPrefix}-performance-dashboard`}
    >
      <h2 className="audit-section-title">Performance dashboard</h2>
      <p className="text-xs mb-3" style={{ color: "rgba(22,25,28,.6)" }}>
        Academy training sessions only — not operational lesson totals or billing.
      </p>

      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4 text-sm mb-4" data-testid={`${testIdPrefix}-session-counts`}>
        <div className="border rounded p-2">
          <MetricTip label="Published sessions" tipKey="published_session_count" tooltips={tips} />
          <p className="text-lg font-semibold">{counts.published_session_count ?? progression.training_sessions_recorded ?? 0}</p>
        </div>
        <div className="border rounded p-2">
          <MetricTip label="Drafts" tipKey="draft_count" tooltips={tips} />
          <p className="text-lg font-semibold">{counts.draft_count ?? 0}</p>
        </div>
        <div className="border rounded p-2">
          <MetricTip label="Approved (unpublished)" tipKey="approved_count" tooltips={tips} />
          <p className="text-lg font-semibold">{counts.approved_count ?? 0}</p>
        </div>
        <div className="border rounded p-2">
          <MetricTip label="Skills assessed" tipKey="skills_assessed" tooltips={tips} />
          <p className="text-lg font-semibold">{overall?.skills_assessed_count ?? 0}</p>
        </div>
      </div>

      {overall?.overall_current_mean != null && (
        <p className="text-sm mb-3" data-testid={`${testIdPrefix}-overall-mean`}>
          <MetricTip label="Current overall mean" tipKey="overall_current_mean" tooltips={tips} />:{" "}
          {overall.overall_current_mean} / 5
        </p>
      )}

      <TrainingProgressDashboard progression={progression} testIdPrefix={testIdPrefix} />
    </section>
  );
}
